export default __webpack_public_path__ + "static/media/DSC_0502.276ee1c2.webp";